import { ComponentType, FC } from 'react';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { History, Location, LocationState } from 'history';

interface match<Params extends { [K in keyof Params]?: string } = {}> {
    params: Params;
    isExact: boolean;
    path: string;
    url: string;
}

export interface DEPRECATED_RouteComponentProps<
    Params extends { [K in keyof Params]?: string } = {},
    S = LocationState,
> {
    history: History<S>;
    location: Location<S>;
    match: match<Params>;
}

export function DEPRECATED_withRouter<P extends DEPRECATED_RouteComponentProps<any>>(
    Component: ComponentType<P>
): ComponentType<Omit<P, keyof DEPRECATED_RouteComponentProps<any>>> {
    const WrappedComponent: FC<P> = props => {
        const history = useHistory<any>();
        const location = useLocation<any>();
        const match = useRouteMatch<any>();

        return <Component {...props} history={history} location={location} match={match} />;
    };
    return WrappedComponent;
}
